export default __webpack_public_path__ + "static/media/TCSenseCar.6af4ce06.svg";